import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorBystart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M11.25 1.817a1.5 1.5 0 0 1 1.5 0l7.694 4.442a1.5 1.5 0 0 1 .75 1.299v8.884a1.5 1.5 0 0 1-.75 1.299l-7.694 4.442a1.5 1.5 0 0 1-1.5 0l-7.694-4.442a1.5 1.5 0 0 1-.75-1.3V7.559a1.5 1.5 0 0 1 .75-1.3l7.694-4.441ZM12 3.116 5.347 6.957 11.815 11h.37l6.468-4.043L12 3.116Zm-.75 9.3-6.944-4.34v8.366l6.944 4.009v-8.035Zm1.5 8.035 6.944-4.01V8.077l-6.944 4.34v8.035Z"
    />
    <path fill="#F7A600" d="M12 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
  </svg>
);
export default SvgTwoColorBystart;
